import { createContext } from 'react';
import _noop from 'lodash/noop';

/**
 * Lets the per-row Approve button ask the list to refresh itself, and tells it whether this user may
 * approve at all.
 *
 * The button is rendered by baseui inside `renderCell`, far from the component holding the list
 * state, so both are passed down through context rather than props.
 */
export interface IApproveContext {
	/** Re-fetches the list. Called after a successful approval so the row shows as approved. */
	refresh: () => void;
	/** Whether the signed-in user holds the override permission. Hides the button; the server still enforces. */
	canApprove: boolean;
}

export const ApproveContext = createContext<IApproveContext>({ refresh: _noop, canApprove: false });
